import React, {FC, useEffect, useMemo, useState} from "react";
import {
    useCheckUserIsManagerQuery,
    useGenerateTgxPdfServiceMutation,
    useGetOrderByOrderIdAndTypeQuery,
    useIsPdfExistMutation,
    useLazyCheckPrimaryCollectorExistActionQuery,
    useLazyGetCadInformationQuery,
    useUpdateProductStatusMutation
} from "../../ordersApi";
import {
    computeBuyerSellerNote,
    computePropertyAddressNote,
    doesCurrentTaxYearMatchCurrentYear,
    fetchPdf,
    getCurrentTaxYear,
    returnNestedKeyValues,
    showToast,
    sortByKeysPriority,
    trimSpace
} from "../../../../helpers/utils/Utils";
import {useParams} from "react-router-dom";
import {
    useGetOrderNoteByTypeAndIdQuery,
    useLazyGetProductTaskListQuery,
    useLazyGetQCLogicResultListQuery
} from "../../productsApi";
import {
    jsonCloneWithDates,
    removeDuplicateAndNegativeItems,
    setTaskList,
    sortCadInfo,
} from "../../../../helpers/utils/OrderDetailUtils";
import SummaryInfoSection from "../Sections/SummaryInfoSection";
import {RequestedInfoSection} from "../Sections/RequestedInfoSection";
import AccountInformation from "./AccountInformation";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";
import EditorAddEditNoteForm from "../../modal/EditorAddEditNoteForm";
import {useUtilDataQuery} from "../../../profile/profileApi";
import {JurisdictionSection} from "../Sections/JurisdictionSection";
import {useLazyGetAllCountyByStateAbbrQuery} from "../../../data/counties/countiesApi";
import {isArray} from "lodash";
import {useDispatch} from "react-redux";
import moment from "moment";
import {tgxApi} from "../../../../app/tgxApi";
import LockConfirmationPopUp from "../../modal/LockConfirmationPopUp";
import TopSection from "../../editor/Common/TopSection/TopSection";
import Preloader from "../../../../components/common/Preloader";
import LeftBar from "../../editor/Common/LeftNavBar/LeftBar";
import GenerateActivePdf from "../../editor/Common/Modals/GenerateActivePdf";
import PdfDeliveryConfirmationModal from "../../editor/Common/Modals/PdfDeliveryConfirmationModal";
import {alphabeticalOrder} from "../../editor/TaxCertificate/Utils";
import {
    useAddNationalParentAccountsForSubdivisionMutation,
    useGetNationalCertificateOptionsByOrderIdQuery,
    useGetNationalOrderResultByOrderIdQuery,
    useGetNationalPropertyPickerResultMutation,
    useLazyCheckNationalTaxOrderResultValidQuery,
    useLazyGetNationalLinkedAccountsQuery,
    useLazyGetNationalSimilarTaxAccountListQuery,
    useSaveNationalOrderResultMutation
} from "../../nationalOrdersApi";
import {
    autoNationalCalculateSummaryRow,
    dummyAssessment,
    getAssessmentList,
    recalculateAssessment,
    sortByYearAndLevyPeriod,
    updateNationalSummarySectionRow,
    updateSummaryRowInfo,
    updateSummaryTotalRowCalculation,
} from "./TaxCertNationalUtil";

const TaxDetailTabSection: FC = () => {

    let {orderId} = useParams();
    const dispatch = useDispatch();

    const [accounts, setAccounts] = useState([]);
    const [certificateNotes, setCertificateNotes] = useState([]);
    const [primaryCollectorId, setPrimaryCollectorId] = useState("");
    const [showAccount, setShowAccount] = useState<any>(0);
    const [certificate, setCertificate] = useState<any>({
        "accounts": accounts, "certificateNotes": certificateNotes, "propertyIds": []
    });
    const [jurisdictionId, setJurisdictionId] = useState(0);
    const [updatedAccountIndexList, setUpdatedAccountIndexList] = useState<any>([]);
    const [removeJurisdiction, setRemoveJurisdiction] = useState(false);
    const [removedAccountIds, setRemovedAccountIds] = useState<any>([]);
    const [isSavedResult, setIsSavedResult] = useState(false);
    const [customerNoteList, setCustomerNoteList] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [certNoteList, setCertNoteList] = useState([]);
    const [productId, setProductId] = useState("");
    const [toggleAccountSection, setToggleAccountSection] = useState(true);
    const [isSendNotification, setIsSendNotification] = useState(false);
    const [products, setProducts] = useState<any>();
    const [similarAccountList, setSimilarAccountList] = useState([]);
    const [tempList, setTempList] = useState([]);
    const [isFetchSimilarAccountList, setIsFetchSimilarAccountList] = useState(false);
    const [vendorTaskList, setVendorTaskList] = useState([]);
    const [editable, setEditable] = useState(true);
    const [assignTo, setAssignTo] = useState("");
    const [qcResultList, setQcResultList] = useState([]);
    const [unAcknowledged, setUnAcknowledged] = useState([]);
    const [isValidDataForPdfGenerate, setIsValidDataForPdfGenerate] = useState<any>(false);
    const [showDeliveryConfirmation, setShowDeliveryConfirmation] = useState(false);
    const [isFetchLinkedAccountList, setIsFetchLinkedAccountList] = useState(false);
    const [orderResultModifiedDate, setOrderResultModifiedDate] = useState(null);
    const [productStatus, setProductStatus] = useState("");
    const [isAccountNoteDeleted, setIsAccountNoteDeleted] = useState(false);
    const [haveOrderResult, setHaveOrderResult] = useState(false);
    const [reloadCadInformation, setReloadCadInformation] = useState(false);
    const [loadingCadInfo, setLoadingCadInfo] = useState(false);
    const [isPropertyResultAvailable, setIsPropertyResultAvailable] = useState(false);
    const [showAddTaxSuitCommentModal, setShowAddTaxSuitCommentModal] = useState(false);
    const [showUpdateTaxSuitCommentModal, setShowUpdateTaxSuitCommentModal] = useState(false);
    const [taxNotesDeleted, setTaxNotesDeleted] = useState(false);
    const [autoCalculate, setAutoCalculate] = useState(false);
    const [updateTotalTotalTaxValue, setUpdateTotalTaxValue] = useState(false);
    const [isAddNewSummaryRow, setIsAddNewSummaryRow] = useState(false);
    const [taxYear, setTaxYear] = useState("");
    const [propertyResultTaxList, setPropertyResultTaxList] = useState<any>([]);
    const [taxCheckedList, setTaxCheckedList] = useState<any>([]);
    const [clearJurisRow, setClearJurisRow] = useState(false);
    const [render, setRender] = useState<number | null>(null);
    const [primaryCollector, setPrimaryCollector] = useState(null);
    const [noteIndex, setNoteIndex] = useState(0);
    const [defaultJurisdictionSize, setDefaultJurisdictionSize] = useState([]);
    const [selectedCloneAccountList, setSelectedCloneAccountList] = useState([]);
    const [showAccountCloneModal, setShowAccountCloneModal] = useState(false);
    const [warningBondModal, setWarningBondModal] = useState(false);
    const [customerId, setCustomerId] = useState("");
    const [curProduct, setCurProduct] = useState({});
    const [moduleAvailableForCounty, setModuleAvailableForCounty] = useState(false);
    const [assignedTeam, setAssignedTeam] = useState(null);
    const [showTeamListModal, setShowTeamListModal] = useState(false);
    const [addedNewAccount, setAddedNewAccount] = useState(false);
    const [addAccountSelectedProperty, setAddAccountSelectedProperty] = useState(null);
    const [customerOrderNumber, setCustomerOrderNumber] = useState("");
    const [showDeleteAccountConfirmation, setShowDeleteAccountConfirmation] = useState(false);
    const [taxAccountNumber, setTaxAccountNumber] = useState("");
    const [address, setAddress] = useState("");
    const [legalDescription, setLegalDescription] = useState("");
    const [ownerName, setOwnerName] = useState("");
    const [isTaxSummaryReset, setIsTaxSummaryReset] = useState(false);
    const [isJurisdictionUpdated, setIsJurisdictionUpdated] = useState(false);
    const [warningModal, setWarningModal] = useState(false);
    const [docList, setDocList] = useState([]);
    const [deliveryEmail, setDeliveryEmail] = useState([]);
    const [activeTaskConfirmation, setActiveTaskConfirmation] = useState(false);
    const [requiresQc, setRequiresQc] = useState(false);
    const [orderStatus, setOrderStatus] = useState("");
    const [lockEditorPopUp, setLockEditorPopUp] = useState(false);
    const [isPdfExist, setIsPdfExist] = useState(true);
    const [disable, setDisable] = useState(false);
    const [warningModalBody, setWarningModalBody] = useState<any>(null);
    const [tenant, setTenant] = useState("");


    const [triggerCheckPrimaryCollectorApi, triggerCheckPrimaryCollectorApiResponse] = useLazyCheckPrimaryCollectorExistActionQuery();
    const [cadInfoData, cadDataInfoApi] = useLazyGetCadInformationQuery();
    const orderResult = useGetNationalOrderResultByOrderIdQuery(orderId)
    const isUserManager = useCheckUserIsManagerQuery(orderId);
    const certificateOptions = useGetNationalCertificateOptionsByOrderIdQuery(orderId);
    const [similarTaxAccountListApi, similarTaxAccountListResponse] = useLazyGetNationalSimilarTaxAccountListQuery();
    const orderQuery = useGetOrderByOrderIdAndTypeQuery({orderId: orderId, orderType: 'OTHER'});
    const {data: notesData} = useGetOrderNoteByTypeAndIdQuery({
        orderId,
        noteTypes: ["TAX", "CUSTOMER"],
    });
    const [productTaskListApi, productTaskListApiResponse] = useLazyGetProductTaskListQuery();
    const [qcLogicResultDataApi, qcLogicResultDataApiResponse] = useLazyGetQCLogicResultListQuery();
    const clonedOrderResultData = JSON.parse(JSON.stringify(orderResult));
    const {data: utilData} = useUtilDataQuery("");
    const [generatePDf, generatePDfApi] = useGenerateTgxPdfServiceMutation();
    const [markAsCompleted, markAsCompletedApi] = useUpdateProductStatusMutation();
    const [checkTaxOrderResultValid] = useLazyCheckNationalTaxOrderResultValidQuery();
    const [checkPdfExist, {data: pdfExistData}] = useIsPdfExistMutation();
    const [countyDataApi, countyDataApiResponse] = useLazyGetAllCountyByStateAbbrQuery();
    const [linkedAccountDataApi, {
        data: linkedAccounts,
        isSuccess,
        isFetching
    }] = useLazyGetNationalLinkedAccountsQuery();
    const [saveOrderResult, saveOrderResultApi] = useSaveNationalOrderResultMutation();
    const [addParentAccountsForSubdivisionApi] = useAddNationalParentAccountsForSubdivisionMutation();
    const [getPropertyPickerResultApi, getPropertyPickerResult] = useGetNationalPropertyPickerResultMutation();

    useEffect(() => {
        if (getPropertyPickerResult?.data?.length > 0) {
            updateAccountList(getPropertyPickerResult.data);
        }
    }, [getPropertyPickerResult]);

    useEffect(() => {
        checkPdfExist({
            'orderId': orderId,
            'orderFileType': ["TaxCertificate"],
            'type': 'New'
        });
    }, []);

    useEffect(() => {
        if (similarTaxAccountListResponse?.data) {
            setTempList(JSON.parse(JSON.stringify(similarTaxAccountListResponse.data)));
        }
    }, [similarTaxAccountListResponse]);

    useEffect(() => {
        if (pdfExistData !== undefined) {
            setIsPdfExist(pdfExistData);
        }
    }, [pdfExistData]);

    useEffect(() => {
        let obj = triggerCheckPrimaryCollectorApiResponse?.data;
        if (obj) {
            setPrimaryCollector(obj);
            setPrimaryCollectorId(obj?.id);
            setModuleAvailableForCounty(obj?.scraperModuleId != null && obj?.scraperModuleId != "")
        }
    }, [triggerCheckPrimaryCollectorApiResponse]);


    const deleteNote = (type: any, index: any) => {
        if (type === "accounts") {
            setIsAccountNoteDeleted(true);
        } else if (type === "taxSuitNotes") {
            setTaxNotesDeleted(true);
        } else {
            const temp = certificate.certificateNotes.filter((_: any, p: number) => p !== index);
            setCertificateNotes(temp);
            setCertificate({
                ...certificate,
                certificateNotes: temp,
            });
        }

        setUpdatedAccountIndexList((prevList: number[]) => {
            if (!prevList.includes(showAccount)) {
                return [...prevList, showAccount];
            }
            return prevList;
        });

        setIsSavedResult(false);

    };

    useEffect(() => {
        if (orderStatus !== '' && (orderStatus === 'AWAITING_LOCATE' || orderStatus === 'NEW') && !isPropertyResultAvailable) {
            setLockEditorPopUp(true);
        }
    }, [orderStatus]);


    useEffect(() => {
        if (cadDataInfoApi?.data) {
            // Create a deep clone or at least clone the parts you mutate to avoid direct mutation
            const updatedCertificate = {...certificate};
            updatedCertificate.accounts = [...certificate.accounts];
            updatedCertificate.accounts[showAccount] = {
                ...certificate.accounts[showAccount],
                cadInformation: cadDataInfoApi.data,
                jurisdictionList: certificate.accounts[showAccount].jurisdictionList.map((el: any) => ({...el})),
            };

            if (haveOrderResult) {
                const jurisdictionList = updatedCertificate.accounts[showAccount].jurisdictionList;
                let data: number[] = [];

                jurisdictionList.forEach((el: any, i: number) => {
                    if (el.placeHolder === true) {
                        const index = cadDataInfoApi.data.findIndex(
                            (pl: any) =>
                                (pl.taxingUnit === el.jurisdictionName || pl.jurisdictionName === el.jurisdictionName) &&
                                pl.jurisdictionId !== null &&
                                pl.jurisdictionId !== ''
                        );

                        if (index > -1) {
                            const collector = cadDataInfoApi.data[index].collectorDTO;

                            el.jurisdictionId = cadDataInfoApi.data[index].jurisdictionId;
                            el.jurisdictionName = cadDataInfoApi.data[index].jurisdictionName;
                            el.collectorName = collector != null && collector !== '' ? collector.name : collector;
                            el.collectorId = collector != null && collector !== '' ? collector.id : collector;
                            el.placeHolder =
                                cadDataInfoApi.data[index].jurisdictionId !== null &&
                                cadDataInfoApi.data[index].jurisdictionId !== ''
                                    ? false
                                    : el.placeHolder;

                            data.push(i);
                        }
                    }
                });

                if (data.length > 0) {
                    setIsSavedResult(false);
                }
            }

            setIsAddNewSummaryRow(true);
            setAutoCalculate(true);
            setUpdateTotalTaxValue(true);

            setUpdatedAccountIndexList((prev: any) => {
                if (!prev.includes(showAccount)) {
                    return [...prev, showAccount];
                }
                return prev;
            });

            setCertificate(updatedCertificate);
        }
    }, [cadDataInfoApi]);


    useEffect(() => {
        if (isTaxSummaryReset) {
            const updatedAccounts = certificate.accounts.map((account: any, index: any) => {
                if (index === showAccount) {
                    return {
                        ...account,
                        summaryList: [{
                            collector: "",
                            collectorAccountNumber: "",
                            levyPeriod: "",
                            taxYear: "",
                            baseTax: "",
                            baseDue: "",
                            paidBy: "",
                            paidBy1: "",
                            asOfDate: ""
                        }],
                        baseTaxTotal: null,
                        baseDueTotal: null,
                        currentMonthTotal: null,
                        nextMonthTotal: null
                    };
                }
                return account;
            });

            setCertificate((prev: any) => ({
                ...prev,
                accounts: updatedAccounts
            }));

            setIsTaxSummaryReset(false);
        }
    }, [isTaxSummaryReset]);


    useEffect(() => {
        if (isAccountNoteDeleted) {
            certificate.accounts[showAccount].accountNotes = certificate.accounts[showAccount].accountNotes.filter((v: any, i: any) => {
                return i !== noteIndex;
            });
            setCertificate(certificate);
            setIsAccountNoteDeleted(false);
        }
        if (taxNotesDeleted) {
            certificate.accounts[showAccount].taxSuitNotes = certificate.accounts[showAccount].taxSuitNotes.filter((v: any, i: any) => {
                return i !== noteIndex;
            });
            setCertificate(certificate);
            setTaxNotesDeleted(false);
        }

    }, [isAccountNoteDeleted, taxNotesDeleted]);

    useEffect(() => {
        if (removeJurisdiction) {
            removeJurisdictionAndBonds();
        }
    }, [removeJurisdiction]);


    useEffect(() => {
        if (autoCalculate) {
            autoNationalCalculateSummaryRow(certificate, setCertificate, showAccount);
            setAutoCalculate(false);
        }
    }, [autoCalculate]);


    const removeJurisdictionAndBonds = () => {
        setCertificate((prevCertificate: any) => {
            // Clone accounts array
            const accountsCopy = [...prevCertificate.accounts];
            // Clone the specific account deeply enough to avoid mutation
            const oldAccount = accountsCopy[showAccount];
            const account = {
                ...oldAccount,
                jurisdictionList: [...oldAccount.jurisdictionList],
                accountNotes: [...oldAccount.accountNotes],
                summaryList: [...oldAccount.summaryList],
                cadInformation: [...(oldAccount.cadInformation || [])]
            };

            const jurisdictionToRemove = account.jurisdictionList[jurisdictionId];


            if (account.jurisdictionList.length === 1) {
                // Removing the last jurisdiction: reset many fields immutably

                const emptySummary = [{
                    collector: "",
                    collectorAccountNumber: "",
                    levyPeriod: "",
                    taxYear: "",
                    baseDue: null,
                    baseTax: null,
                    nextPeriodDue: null,
                    nextNextPeriodDue: null,
                    asOfDate: null,
                }];

                const emptyJurisdiction = [{
                    collectorName: "",
                    jurisdictionId: "",
                    collectorId: "",
                    jurisdictionName: "",
                    taxYear: "",
                    levyPeriod: null,
                    nextPeriodDue: null,
                    nextNextPeriodDue: null,
                    paidDate: "",
                    dueDate: null,
                    billedDate: null,
                    baseTax: "",
                    baseDue: "",
                    status: null,
                    collectorAccountNumber: "",
                    nonCollecting: false,
                    inActive: false,
                    tax_rate_List: [],
                    taxDataSource: null,
                    asOfDate: null,
                    placeHolder: false,
                }];

                // Filter notes not related to jurisdiction to remove
                const updatedNotes = account.accountNotes.filter(
                    (note: any) => note.relationalId !== jurisdictionToRemove.jurisdictionId
                );

                accountsCopy[showAccount] = {
                    ...account,
                    accountNotes: updatedNotes,
                    summaryList: emptySummary,
                    jurisdictionList: emptyJurisdiction,
                    taxRateTotal: null,
                    cadInformation: [],
                    baseTaxTotal: null,
                    baseDueTotal: null,
                    currentMonthTotal: null,
                    nextMonthTotal: null
                };
            } else {
                // More than one jurisdiction: remove selected one and update related lists immutably

                const newJurisdictionList = account.jurisdictionList.filter((_: any, i: number) => i !== jurisdictionId);

                const {collectorName, taxYear, jurisdictionId: jid} = jurisdictionToRemove;

                // Remove notes related to the removed jurisdiction if no remaining jurisdiction with same id
                const stillHasJurisdictionWithId = newJurisdictionList.some((j: any) => j.jurisdictionId === jid);

                const updatedNotes = stillHasJurisdictionWithId
                    ? account.accountNotes
                    : account.accountNotes.filter((note: any) => note.relationalId !== jid);

                // Find summary index matching removed jurisdiction collector and taxYear
                const summaryIndex = account.summaryList.findIndex(
                    (sum: any) => sum.collector === collectorName && parseInt(sum.taxYear) === parseInt(taxYear)
                );

                // Find remaining jurisdictions for that collector and taxYear
                const remainingJurisForSummary = newJurisdictionList.filter(
                    (j: any) => j.collectorName === collectorName && parseInt(j.taxYear) === parseInt(taxYear)
                );

                let newSummaryList = [...account.summaryList];

                if (remainingJurisForSummary.length === 0 && summaryIndex !== -1) {
                    // Remove that summary item
                    newSummaryList = newSummaryList.filter((_: any, i: number) => i !== summaryIndex);
                } else if (summaryIndex !== -1) {
                    // Update that summary item immutably
                    newSummaryList = updateSummaryRowInfo(newSummaryList, remainingJurisForSummary, summaryIndex);
                }

                // Create updated account object with all immutable updates
                const updatedAccount = {
                    ...account,
                    jurisdictionList: newJurisdictionList,
                    accountNotes: updatedNotes,
                    summaryList: newSummaryList,
                };

                // update summary totals immutably, assuming it returns a new account
                accountsCopy[showAccount] = updateSummaryTotalRowCalculation(updatedAccount, updatedAccount.summaryList);
            }

            return {
                ...prevCertificate,
                accounts: accountsCopy
            };
        });

        setRemoveJurisdiction(false);
        setWarningBondModal(false);
        setRender(new Date().getMilliseconds());
    };

    async function addParentAccountsForSubdivision(subdivisionId: any, setDisable: any, setShow: any) {
        try {
            setDisable(true);
            const updatedCertificate = jsonCloneWithDates(certificate);
            updatedCertificate.accounts[showAccount] = {
                ...updatedCertificate.accounts[showAccount],
                subdivisionId: subdivisionId,
            };

            setCertificate(updatedCertificate);
            const orderResults = handleOrderResultSubmit(true, updatedCertificate);

            const response: any = await addParentAccountsForSubdivisionApi({subdivisionId, orderResults}).unwrap();

            if (response?.errorCode === 200) {
                setDisable(false);
                showToast(`${response.noOfAccountsAdded} new Certificate Accounts have been added!`, 'success');
                setShow(false);
            } else {
                setDisable(false);
                setShow(false);
            }
        } catch (error: any) {
            setDisable(false);
            setShow(false);
            showToast(error?.message || "Something went wrong", 'error');
        }
    }

    useEffect(() => {
        if (selectedCloneAccountList.length <= 0) return;

        const cloneAccounts = async () => {
            const temp: any[] = [];
            const propertyIds: any[] = [...certificate.propertyIds];

            const updatedAccounts = [...certificate.accounts];
            const updatedIndices: number[] = [...updatedAccountIndexList];
            const newRemovedAccountIds = [...removedAccountIds];

            selectedCloneAccountList.forEach((el: any) => {
                const accountDTO = {
                    ...el.certificateAccountDTO,
                    id: null,
                    orderPropertyId: null
                };

                const index = updatedAccounts.findIndex(
                    (pDay) => trimSpace(accountDTO.propertyId) === trimSpace(pDay.propertyId)
                );

                if (index > -1) {
                    const existingId = updatedAccounts[index].id;
                    if (existingId != null && existingId !== "") {
                        newRemovedAccountIds.push(existingId);
                    }
                    updatedAccounts[index] = accountDTO;
                    updatedIndices.push(index);
                } else {
                    updatedAccounts.push(accountDTO);
                    updatedIndices.push(updatedAccounts.length - 1);
                    propertyIds.push({id: el.certificateAccountDTO.propertyId, visibility: true});
                }
            });

            let updatedCertificate = {...certificate, accounts: updatedAccounts, propertyIds};

            // Use Promise.all to wait for all accountInfo calls
            const updatedResults = await Promise.all(
                updatedAccounts.map((account, i) =>
                    accountInfo(account, i, true, temp, updatedCertificate)
                )
            );

            // Extract results
            updatedCertificate.accounts = updatedResults.map((res) => res.updatedAccountEntry);
            updatedCertificate.propertyIds = updatedResults.map((res) => ({
                id: res.updatedPropertyId,
                visibility: true,
            }));

            // Set everything
            setRemovedAccountIds(newRemovedAccountIds);
            setCertificate({
                ...certificate,
                accounts: updatedCertificate.accounts,
                propertyIds: updatedCertificate.propertyIds
            });
            recalculateAssessment(showAccount, {
                ...certificate,
                accounts: updatedCertificate.accounts,
                propertyIds: updatedCertificate.propertyIds
            }, setRender, setCertificate);

            setShowAccount(updatedCertificate.accounts.length - 1);
            showToast("Successfully cloned all accounts!");
            setUpdatedAccountIndexList(updatedIndices);
            setIsSavedResult(false);

            setShowAccountCloneModal(false);
        };

        cloneAccounts();
    }, [selectedCloneAccountList]);


    useEffect(() => {
        if (notesData && notesData.error === undefined) {
            setCertNoteList(notesData?.filter((el: any) => el.noteType === "TAX"));
            setCustomerNoteList(notesData?.filter((el: any) => el.noteType === "CUSTOMER"));
        }
    }, [notesData]);

    useEffect(() => {
        if (orderQuery?.data) {
            let product = orderQuery?.data?.products?.filter((obj: any) => obj.type.includes("TAX_"))[0];
            setProducts(product)
            setCustomerId(orderQuery.data?.customerDTO?.id);
            setCustomerOrderNumber(orderQuery.data?.customerOrderNumber);
            setTenant(orderQuery.data.tenant);
            setProductStatus(product?.productStatus);
            setCurProduct(product);
            setTaxAccountNumber(orderQuery.data?.properties[0]?.taxIdentifier);
            setAddress(orderQuery.data?.properties[0]?.addressLine1);
            setLegalDescription(orderQuery.data?.properties[0]?.legalDescription);
            setOwnerName(orderQuery.data?.properties[0]?.sellerName);
            setIsPropertyResultAvailable(orderQuery.data?.properties[0]?.propertyResult !== null && orderQuery.data?.properties[0]?.propertyResult !== "");

            countyDataApi(orderQuery.data.state);
            productTaskListApi(product.id);
            qcLogicResultDataApi(product.id);

            orderQuery.data?.properties?.map((property: any, index: number) => {
                if (index === 0) {
                    if (property.propertyResult != null && property.propertyResult.parsedAddress !== null && property.propertyResult.parsedAddress !== '' && property.propertyResult.parsedAddress.county !== null && property.propertyResult.parsedAddress.county !== '') {

                        triggerCheckPrimaryCollectorApi({
                            county: property.propertyResult.parsedAddress.county,
                            stateAbbreviation: property.propertyResult.parsedAddress.state
                        });

                    } else {
                        triggerCheckPrimaryCollectorApi({
                            county: orderQuery.data.county,
                            stateAbbreviation: orderQuery.data.state
                        });
                    }
                }
            })

            // setDocList(orderData.items?.documents);

            let assignTo = product.assignedTo;
            setEditable(orderQuery.data.active && assignTo === utilData?.userName);
            setAssignTo(assignTo);
            setProductId(product.id);
            setRequiresQc(product.requiresQc);
            setOrderStatus(orderQuery.data.orderStatus);
        }
    }, [orderQuery?.data, utilData]);

    useMemo(() => {
        if (showAccount !== null) {
            if (certificate.accounts.length > 0) {
                setSimilarAccountList(tempList.length > 0 ? tempList.filter((el: any) => el.propertyId === certificate.accounts[showAccount].propertyId) : []);
            }
        }
    }, [showAccount]);


    useEffect(() => {

        setSimilarAccountList(tempList.length > 0 ? tempList.filter((el: any) => el.propertyId === certificate.accounts[showAccount]?.propertyId) : []);

    }, [tempList]);


    useEffect(() => {
        if (!isFetchSimilarAccountList) {
            return;
        }

        let propertyIds: any = [];
        certificate.accounts.filter((el: any) => {
            if (el.original) {
                if (el.propertyId) {
                    propertyIds.push(el.propertyId);
                }
            }
        });


        if (propertyIds.length > 0) {
            similarTaxAccountListApi({orderId: orderId, propertyIds});
        }

        setIsFetchSimilarAccountList(false);
    }, [isFetchSimilarAccountList]);


    useEffect(() => {

        if (productTaskListApiResponse?.data) {
            setTaskList(productTaskListApiResponse?.data, setVendorTaskList, orderQuery?.data?.properties);
        }

    }, [productTaskListApiResponse]);

    const handleMarkAsComplete = async () => {
        try {
            const result = await markAsCompleted({
                productId: productId,
                productStatus: "COMPLETED"
            }).unwrap();

            if (result?.errorCode === 200) {
                showToast("Mark as completed successfully!", "success");
                setProductStatus("COMPLETED");
                if (setShowAccount) {
                    setShowAccount(0);
                }
            }
        } catch (error: any) {
            showToast(error?.message || "Something went wrong.", "error");
        }
    };

    useEffect(() => {
        if (addedNewAccount) {
            const assessment = dummyAssessment();
            const lastDayOfCurrentMonth = moment().endOf('month').format("YYYY-MM-DD");
            const lastDayOfNextMonth = moment().add(1, 'months').endOf('month').format("YYYY-MM-DD");

            const juris = {
                jurisdictionId: "",
                levies: []
            };

            const accountObj = {
                sort: certificate.accounts.length,
                orderId,
                customerOrderNumber,
                nextPeriodDueDate: lastDayOfCurrentMonth,
                nextNextPeriodDueDate: lastDayOfNextMonth,
                propertyId: returnNestedKeyValues(addAccountSelectedProperty, "propertyResult.taxId"),
                ownerName: "",
                ownerAddress: "",
                subdivisionId: "",
                acreage: "",
                geographicId: "",
                subdivisionCode: "",
                stateCodes: [],
                deed: "",
                legalDescription: returnNestedKeyValues(addAccountSelectedProperty, "propertyResult.legalDescription"),
                situsAddress: returnNestedKeyValues(addAccountSelectedProperty, "propertyResult.address"),
                taxYear: getCurrentTaxYear(),
                orderPropertyId: returnNestedKeyValues(addAccountSelectedProperty, "id"),
                accountNotes: [],
                assessment,
                jurisdictions: juris,
                taxDataSource: "EDITOR",
                asOfDate: null,
                jurisdictionList: [{
                    collectorName: "",
                    jurisdictionName: "",
                    collectorAccountNumber: "",
                    nonCollecting: false,
                    inActive: false,
                    jurisdictionId: "",
                    levyPeriod: null,
                    taxYear: "",
                    nextPeriodDue: null,
                    nextNextPeriodDue: null,
                    paidDate: "",
                    dueDate: null,
                    billedDate: null,
                    baseDue: "",
                    baseTax: "",
                    levyStaus: "",
                    placeHolder: false,
                    collectorId: "",
                    tax_rate_List: [],
                    taxDataSource: "EDITOR",
                    asOfDate: null,
                    collectorLink: null,
                }],
                summaryList: [{
                    collector: "",
                    collectorAccountNumber: "",
                    levyPeriod: "",
                    taxYear: "",
                    baseDue: null,
                    baseTax: null,
                    nextPeriodDue: "",
                    nextNextPeriodDue: "",
                    asOfDate: null
                }],
                taxRateTotal: null,
                cadInformation: [],
                baseTaxTotal: null,
                baseDueTotal: null,
                currentMonthTotal: null,
                nextMonthTotal: null,
                original: true
            };

            const newAccounts = [...certificate.accounts, accountObj];
            const newPropertyIds = [...certificate.propertyIds, {id: accountObj.propertyId, visibility: true}];

            setCertificate({
                ...certificate,
                accounts: newAccounts,
                propertyIds: newPropertyIds
            });

            setAddedNewAccount(false);
            setShowAccount(newAccounts.length - 1);

            if (Array.isArray(updatedAccountIndexList)) {
                setUpdatedAccountIndexList((prev: number[]) => {
                    if (!prev.includes(newAccounts.length - 1)) {
                        return [...prev, newAccounts.length - 1];
                    }
                    return prev;
                });
            } else if (updatedAccountIndexList.current) {
                if (!updatedAccountIndexList.current.includes(newAccounts.length - 1)) {
                    updatedAccountIndexList.current.push(newAccounts.length - 1);
                }
            }

            setIsSavedResult(false);

        }
    }, [addedNewAccount]);


    useMemo(() => {
        if (qcLogicResultDataApiResponse?.data) {
            setQcResultList(qcLogicResultDataApiResponse?.data);
            setUnAcknowledged(JSON.parse(JSON.stringify(qcLogicResultDataApiResponse?.data)).filter((el: any) => el.result && (el.acknowledgedBy == null || el.acknowledgedBy === "")));
        }
    }, [qcLogicResultDataApiResponse]);

    useEffect(() => {
        const fetchCadInfo = async () => {
            if (reloadCadInformation && certificate.accounts?.[showAccount]) {
                const account = certificate.accounts[showAccount];
                const cadInfoList = account.cadInformation;
                const countyId = account.countyId ?? orderQuery.data?.countyId;

                setLoadingCadInfo(true);
                try {
                    await cadInfoData({
                        list: cadInfoList,
                        countyId: countyId
                    }).unwrap();
                    showToast("CAD Information Successfully Updated!");
                } catch (error) {
                    console.error("Failed to fetch CAD info", error);
                    showToast("Failed to fetch CAD info", "error");
                } finally {
                    setLoadingCadInfo(false);
                    setReloadCadInformation(false);
                }
            }
        };

        fetchCadInfo();
    }, [reloadCadInformation]);

    useEffect(() => {
        if (!orderQuery?.data || orderQuery?.data?.error !== undefined) return;
        setIsPropertyResultAvailable(!!orderQuery?.data?.properties?.[0]?.propertyResult);

        if (orderResult?.data === null && certificate.accounts?.length !== orderQuery?.data?.properties?.length) {
            const propertyResultTaxSet = new Set([...propertyResultTaxList]);
            const taxCheckedSet = new Set([...taxCheckedList]);
            const updatedAccounts = [...certificate.accounts];
            const updatedPropertyIds = [...certificate.propertyIds];

            orderQuery?.data?.properties?.forEach((property: any, index: any) => {
                const result = property.propertyResult;
                if (!result || result.skipAutomation) return;

                const propertyId = result.taxId || '';
                const geoId = result.geoId || '';
                const legalDesc = result.legalDescription ?? property.legalDescription;
                const situsAddress = result.address ?? property.addressLine1;

                if (propertyId) {
                    propertyResultTaxSet.add(propertyId);
                    taxCheckedSet.add(propertyId);
                }

                updatedPropertyIds.push({id: propertyId, visibility: true});

                const lastDayOfCurrentMonth = moment().endOf('month');
                const lastDayOfNextMonth = moment().add(1, 'months').endOf('month');
                let juris = {
                    "jurisdictionId": "", "levies": []
                }
                const accountObj = {
                    sort: index,
                    orderId,
                    customerOrderNumber,
                    nextPeriodDueDate: lastDayOfCurrentMonth.format("YYYY-MM-DD"),
                    nextNextPeriodDueDate: lastDayOfNextMonth.format("YYYY-MM-DD"),
                    propertyId,
                    ownerName: result.primaryOwner ?? orderQuery.data.sellerName,
                    ownerAddress: "",
                    subdivisionId: "",
                    acreage: "",
                    geographicId: geoId,
                    subdivisionCode: "",
                    stateCodes: [],
                    deed: "",
                    legalDescription: legalDesc,
                    situsAddress,
                    taxYear: getCurrentTaxYear(),
                    taxDataSource: "EDITOR",
                    asOfDate: null,
                    orderPropertyId: property.id,
                    accountNotes: [],
                    assessment: dummyAssessment(),
                    jurisdictions: juris,
                    jurisdictionList: [{
                        collectorName: "",
                        jurisdictionName: "",
                        jurisdictionId: "",
                        taxYear: "",
                        levyPeriod: null,
                        status: null,
                        dueDate: null,
                        billedDate: null,
                        paidDate: null,
                        baseTax: "",
                        baseDue: "",
                        nextPeriodDue: "",
                        nextNextPeriodDue: "",
                        collectorAccountNumber: "",
                        nonCollecting: false,
                        inActive: false,
                        collectorId: "",
                        tax_rate_List: [],
                        asOfDate: null,
                        taxDataSource: null,
                        placeHolder: false
                    }],
                    summaryList: [{
                        collector: "",
                        levyPeriod: "",
                        taxYear: "",
                        baseDue: "",
                        baseTax: "",
                        nextPeriodDue: "",
                        nextNextPeriodDue: "",
                        asOfDate: null
                    }],
                    cadInformation: [],
                    taxRateTotal: null,
                    baseTaxTotal: null,
                    baseDueTotal: null,
                    currentMonthTotal: null,
                    nextMonthTotal: null,
                    original: true
                };

                updatedAccounts.push(accountObj);
            });

            const note = computeBuyerSellerNote(orderQuery.data.buyerName, orderQuery.data.sellerName);
            const propertyNote = computePropertyAddressNote(orderQuery, certificate);

            const updatedCertificate = {
                ...certificate,
                accounts: updatedAccounts,
                propertyIds: updatedPropertyIds,
                certificateNotes: []
            };

            if (note) {
                updatedCertificate.certificateNotes.push({comment: note, certificateLevelNote: true});
            }

            if (propertyNote) {
                updatedCertificate.certificateNotes.push({comment: propertyNote, certificateLevelNote: true});
            }

            setPropertyResultTaxList(Array.from(propertyResultTaxSet));
            setTaxCheckedList(Array.from(taxCheckedSet));
            setCertificate(updatedCertificate);
            setShowAccount(0);
            setShowForm(true);
        }

        setIsFetchSimilarAccountList(true);
    }, [orderQuery, orderResult]);


    useEffect(() => {
        if (
            clonedOrderResultData === undefined ||
            clonedOrderResultData.data === undefined ||
            !clonedOrderResultData?.data?.certificate?.accounts?.length
        ) {
            return;
        }

        const initialize = async () => {
            try {
                // Step 1: Validate order result
                const {data} = await checkTaxOrderResultValid(clonedOrderResultData.data);
                setIsValidDataForPdfGenerate(data === true);

                // Step 2: Set initial states
                setHaveOrderResult(true);
                setOrderResultModifiedDate(orderResult.data.certificate.accounts[0].modifiedDate);

                const updatedCertificate = {
                    ...certificate,
                    accounts: [...(orderResult?.data?.certificate?.accounts ?? [])],
                    certificateNotes: [...(orderResult?.data?.certificate?.certificateNotes ?? [])],
                };

                const temp: any[] = [];

                const accountResults = updatedCertificate.accounts.map((account: any, i: number) => {
                    return accountInfo(account, i, account.original, temp, updatedCertificate);
                });

                accountResults.forEach(({updatedAccountEntry, updatedPropertyId}: any, i: any) => {
                    updatedCertificate.accounts[i] = updatedAccountEntry;
                    updatedCertificate.propertyIds[i] = {id: updatedPropertyId, visibility: true};
                });

                const finalAccounts = accountResults.map((res: any) => res.updatedAccountEntry);
                const updatedPropertyIds = accountResults.map((res: any) => ({
                    id: res.updatedPropertyId,
                    visibility: true,
                }));

                // Step 4: Update state
                setCertificate({
                    accounts: finalAccounts,
                    certificateNotes: updatedCertificate.certificateNotes,
                    propertyIds: updatedPropertyIds,
                });

                // Step 5: Set misc states
                // @ts-ignore
                setDefaultJurisdictionSize(temp);
                recalculateAssessment(showAccount, {
                    accounts: finalAccounts,
                    certificateNotes: updatedCertificate.certificateNotes,
                    propertyIds: updatedPropertyIds,
                }, setRender, setCertificate);
                setIsSavedResult(true);
                setShowAccount(0);
                setShowForm(true);

            } catch (error) {
                console.error("Error during initialize in useEffect:", error);
            }
        };

        initialize();
    }, [orderResult?.data]);


    const accountInfo = (accounts: any, i: any, isOriginal: boolean, temp: any = [], updatedCertificate: any) => {
        const jurisNewList: any[] = [];
        let summaryList: any[] = [];

        const updatedPropertyId = isOriginal
            ? accounts.propertyId
            : typeof accounts.propertyId === 'string' && !accounts.propertyId.includes('-CLONE')
                ? `${accounts.propertyId}-CLONE`
                : accounts.propertyId;


        const updatedAccount = {
            ...accounts,
            propertyId: updatedPropertyId,
            original: isOriginal,
            orderId: orderId
        };

        if (Array.isArray(accounts.jurisdictions)) {
            accounts.jurisdictions.forEach((jurisdiction: any) => {
                temp.push(jurisdiction.jurisdictionName);

                const collectorName = jurisdiction.collector?.collectorName || jurisdiction.collector;
                const collectorId = jurisdiction.collector?.collectorId || jurisdiction.collector;
                const collectorLink = jurisdiction.collector?.collectorLink || null;

                if (Array.isArray(jurisdiction.levies) && jurisdiction.levies.length > 0) {
                    jurisdiction.levies.forEach((leviesList: any) => {
                        const levy = {
                            collectorName: collectorName,
                            jurisdictionName: jurisdiction.jurisdictionName,
                            jurisdictionId: jurisdiction.jurisdictionId,
                            taxYear: leviesList.taxYear,
                            levyPeriod: leviesList.levyPeriod,
                            baseTax: leviesList.baseTax,
                            baseDue: leviesList.baseDue,
                            status: leviesList.status,
                            paidDate: leviesList.paidDate,
                            nextPeriodDue: leviesList.nextPeriodDue,
                            nextNextPeriodDue: leviesList.nextNextPeriodDue,
                            dueDate: leviesList.dueDate,
                            billedDate: leviesList.billedDate,
                            collectorId: collectorId,
                            tax_rate_List: [],
                            asOfDate: jurisdiction.asOfDate,
                            taxDataSource: jurisdiction.taxDataSource,
                            placeHolder: jurisdiction.placeHolder,
                            collectorAccountNumber: jurisdiction.collectorAccountNumber,
                            nonCollecting: jurisdiction.nonCollecting === null ? false : jurisdiction.nonCollecting,
                            inActive: jurisdiction.inActive === null ? false : jurisdiction.inActive,
                            id: jurisdiction.id,
                            collectorLink: collectorLink,

                        };
                        jurisNewList.push(levy);

                        if (!jurisdiction.placeHolder) {

                            const collectorName = jurisdiction.collector ? jurisdiction.collector.collectorName : jurisdiction.collector;
                            const collectorId = jurisdiction.collector ? jurisdiction.collector.collectorId : null;


                            const existingSummaryIndex = summaryList.findIndex(
                                (obj: any) => obj.collector === collectorName && obj.taxYear === leviesList.taxYear
                            );

                            if (existingSummaryIndex === -1) {
                                let asOfDateArray: any = [];

                                accounts.jurisdictions.map((cur: any) => {
                                    if (cur.asOfDate !== null && cur.asOfDate !== '') {
                                        asOfDateArray.push(moment(cur['asOfDate'], 'YYYY-MM-DD').valueOf());
                                    }
                                });

                                let collectorAccountNumber = null;
                                if (collectorId !== null) {
                                    let jurisdictionList = accounts.jurisdictions.filter((el: any) =>
                                        el.collector &&
                                        el.collector?.collectorId === collectorId &&
                                        el.collectorAccountNumber
                                    );
                                    if (jurisdictionList.length > 0) {
                                        collectorAccountNumber = jurisdictionList[0].collectorAccountNumber;
                                    }
                                }

                                summaryList.push({
                                    "collector": collectorName,
                                    "levyPeriod": leviesList.levyPeriod,
                                    "taxYear": leviesList.taxYear,
                                    "collectorAccountNumber": collectorAccountNumber === null ? jurisdiction.collectorAccountNumber : collectorAccountNumber,
                                    "baseTax": leviesList.baseTax,
                                    "baseDue": leviesList.baseDue,
                                    "nextPeriodDue": leviesList.nextPeriodDue,
                                    "nextNextPeriodDue": leviesList.nextNextPeriodDue,
                                    "asOfDate": asOfDateArray.length === 0 ? null : new Date(Math.min(...asOfDateArray))
                                });

                            } else {
                                const list = jurisNewList.filter((obj: any) =>
                                    obj.collectorName === collectorName &&
                                    obj.taxYear === leviesList.taxYear &&
                                    obj.placeHolder === false
                                );

                                summaryList = updateSummaryRowInfo(summaryList, list, existingSummaryIndex);
                            }
                        }
                    });
                } else {
                    jurisNewList.push({
                        collectorName: jurisdiction.collector != null && jurisdiction.collector !== '' ? jurisdiction.collector.collectorName : jurisdiction.collector,
                        jurisdictionName: jurisdiction.jurisdictionName,
                        jurisdictionId: jurisdiction.jurisdictionId,
                        balance: "",
                        taxYear: "",
                        levyPeriod: null,
                        penaltiesInterest: "",
                        baseTax: "",
                        baseDue: "",
                        dueDate: null,
                        billedDate: null,
                        note: "",
                        collectorId: jurisdiction.collector != null && jurisdiction.collector !== '' ? jurisdiction.collector.collectorId : jurisdiction.collector,
                        tax_rate_List: [],
                        asOfDate: jurisdiction.asOfDate,
                        taxDataSource: jurisdiction.taxDataSource,
                        placeHolder: jurisdiction.placeHolder,
                        collectorAccountNumber: jurisdiction.collectorAccountNumber,
                        nonCollecting: jurisdiction.nonCollecting == null ? false : jurisdiction.nonCollecting,
                        inActive: jurisdiction.inActive == null ? false : jurisdiction.inActive,
                        id: jurisdiction.id,
                        collectorLink: jurisdiction.collector != null && jurisdiction.collector !== '' ? jurisdiction.collector.collectorLink : null
                    });
                }
            });
        }

        const assessment = getAssessmentList(updatedCertificate, i);
        const jurisdictionList = jurisNewList.length > 0
            ? sortByYearAndLevyPeriod(jurisNewList)
            : [{
                collectorName: "",
                jurisdictionName: "",
                jurisdictionId: "",
                taxYear: "",
                levyPeriod: null,
                status: null,
                nextPeriodDue: null,
                nextNextPeriodDue: null,
                dueDate: null,
                billedDate: null,
                baseTax: "",
                baseDue: "",
                paidDate: "",
                collectorAccountNumber: "",
                collectorId: "",
                tax_rate_List: [],
                asOfDate: null,
                taxDataSource: null,
                placeHolder: false,
                nonCollecting: false,
                inActive: false
            }];

        const summaryListFinal = summaryList.length > 0
            ? sortByYearAndLevyPeriod(summaryList)
            : [{
                collector: "",
                collectorAccountNumber: "",
                levyPeriod: "",
                taxYear: "",
                baseTax: null,
                baseDue: null,
                nextPeriodDue: null,
                nextNextPeriodDue: null,
                asOfDate: null
            }];

        const updatedAccountEntry = {
            ...updatedAccount,
            assessment,
            sort: i,
            jurisdictionList,
            summaryList: summaryListFinal,
            cadInformation: accounts.cadInformation,
        };

        const finalAccount = updateSummaryTotalRowCalculation(updatedAccountEntry, summaryListFinal);

        return {
            updatedAccountEntry: finalAccount,
            updatedPropertyId
        };
    };

    useEffect(() => {
        if (!isFetchLinkedAccountList) {
            return;
        }

        setIsFetchLinkedAccountList(true);

        const propertyIds = certificate.accounts.reduce((acc: string[], el: any) => {
            if (el.original && el.propertyId) {
                acc.push(el.propertyId);
            }
            return acc;
        }, []);

        if (propertyIds.length === 0) {
            setIsFetchLinkedAccountList(false);
            setIsFetchLinkedAccountList(false);
            return;
        }

        linkedAccountDataApi({primaryCollectorId: primaryCollectorId, accountIds: propertyIds});

        setIsFetchLinkedAccountList(false);
    }, [isFetchLinkedAccountList]);


    useEffect(() => {
        if (!isSuccess) return;

        if (linkedAccounts?.length > 0) {
            updateAccountList(linkedAccounts); // await the async function
            showToast("Successfully added all linked accounts!");
        } else {
            showToast("No account found to link!");
        }
        setIsFetchLinkedAccountList(false);
    }, [linkedAccounts, isSuccess]);


    const updateAccountList = (data: any) => {
        const temp: any[] = [];

        const newAccounts = [...certificate.accounts];
        const updatedAccountIndexList: number[] = [];
        const propertyIds: any[] = [...certificate.propertyIds];

        data.forEach((account: any) => {
            setUpdatedAccountIndexList((prev: number[]) =>
                prev.includes(newAccounts.length) ? prev : [...prev, newAccounts.length]
            );
            newAccounts.push(account);
            propertyIds.push({id: account.propertyId, visibility: true});
        });

        const updatedCertificate = {...certificate, accounts: newAccounts, propertyIds};

        const results = newAccounts.map((account, i) =>
            accountInfo(account, i, true, temp, updatedCertificate)
        );

        const updatedAccounts = results.map((res) => res.updatedAccountEntry);
        const updatedPropertyIds = results.map((res) => ({id: res.updatedPropertyId, visibility: true}));

        setCertificate({
            ...certificate,
            accounts: updatedAccounts,
            propertyIds: updatedPropertyIds,
        });
        recalculateAssessment(showAccount, {
            ...certificate,
            accounts: updatedAccounts,
            propertyIds: updatedPropertyIds,
        }, setRender, setCertificate);
        setUpdatedAccountIndexList(updatedAccountIndexList);
        setShowAccount(updatedAccounts.length - 1);
        setIsSavedResult(false);
    };


    useEffect(() => {
        if (clearJurisRow) {
            setCertificate((prevCertificate: any) => {
                const updatedAccounts = [...prevCertificate.accounts];
                const curAccount = {...updatedAccounts[showAccount]};
                const jurisdiction = {...curAccount.jurisdictionList[jurisdictionId]};
                const collector = jurisdiction.collectorName;
                const rateYear = jurisdiction.taxYear;
                const i = curAccount.summaryList.findIndex(
                    (obj: any) =>
                        obj.collector === collector &&
                        parseInt(obj.taxYear) === parseInt(rateYear)
                );

                // Reset jurisdiction
                curAccount.jurisdictionList = [...curAccount.jurisdictionList];

                if (rateYear === '') {
                    // Only jurisdiction data reset
                    curAccount.jurisdictionList[jurisdictionId] = getResetJurisdiction(jurisdiction);
                    updatedAccounts[showAccount] = curAccount;
                    return {
                        ...prevCertificate,
                        accounts: updatedAccounts
                    };
                }

                if (i !== -1) {
                    const matchingJurisdictions = curAccount.jurisdictionList.filter(
                        (value: any) =>
                            value.collectorName === collector &&
                            parseInt(value.taxYear) === parseInt(rateYear)
                    );
                    curAccount.jurisdictionList[jurisdictionId] = getResetJurisdiction(jurisdiction);
                    if (matchingJurisdictions.length === 0) {
                        curAccount.summaryList = curAccount.summaryList.filter((_: any, idx: number) => idx !== i);
                    } else {
                        curAccount.summaryList = updateSummaryRowInfo(
                            curAccount.summaryList,
                            matchingJurisdictions,
                            i
                        );
                    }

                    updatedAccounts[showAccount] = curAccount;
                    setUpdateTotalTaxValue(true);
                    return {
                        ...prevCertificate,
                        accounts: updatedAccounts
                    };
                }

                return prevCertificate;
            });

            setIsSavedResult(false);
            setAutoCalculate(true);
            setClearJurisRow(false);
        }
    }, [clearJurisRow]);


    function getResetJurisdiction(original: any) {
        return {
            ...original,
            jurisdictionName: '',
            collectorName: '',
            jurisdictionId: '',
            collectorId: '',
            taxYear: '',
            levyPeriod: null,
            nextPeriodDue: null,
            nextNextPeriodDue: null,
            paidDate: null,
            dueDate: null,
            billedDate: null,
            baseTax: null,
            baseDue: null,
            status: null,
            tax_rate_List: [],
            asOfDate: null,
            taxDataSource: null,
            collectorAccountNumber: '',
            nonCollecting: false,
            inActive: false,
            placeHolder: false
        };
    }


    function isJurisdictionChanged() {
        let temp1: any = [];

        let exist = vendorTaskList.length > 0 && vendorTaskList.findIndex((obj: any) => obj.type === "BONDS" && (obj.status === "PENDING")) > -1;

        certificate.accounts.map((accounts: any) => {
            if (accounts?.jurisdictionList?.length > 0) {
                accounts?.jurisdictionList?.map((jurisdiction: any) => {
                    jurisdiction.jurisdictionName != null && jurisdiction.jurisdictionName !== "" && temp1.push(jurisdiction.jurisdictionName);
                })
            }
        });

        if (defaultJurisdictionSize.length !== temp1.length && exist) {
            setIsJurisdictionUpdated(true);
        } else if (JSON.stringify(alphabeticalOrder(defaultJurisdictionSize)) !== JSON.stringify(alphabeticalOrder(temp1)) && exist) {
            setIsJurisdictionUpdated(true);
        } else {
            handleOrderResultSubmit();
        }
    }

    const handleOrderResultSubmit = (isAddToParent = false, currentCertificate?: any) => {
        // Use the passed certificate if available, otherwise use the one from the closure
        const certificateToUse = currentCertificate || certificate;
        setIsJurisdictionUpdated(false);

        const propertyList = certificateToUse.propertyIds
            .map((el: any) => el.id !== null ? el.id.trim() : el.id);

        let similarPropertyExist = (new Set(propertyList)).size !== certificateToUse.propertyIds.length;

        if (similarPropertyExist) {
            setWarningModalBody("Duplicate accounts found. Please resolve before saving.");
            setWarningModal(true);
        } else {
            let accountList: any[];
            if (!isAddToParent || Object.keys(isAddToParent).length > 0) {
                const uniqueIndexes = removeDuplicateAndNegativeItems(updatedAccountIndexList);
                // Step 2: Add unique accounts from certificate.accounts based on uniqueIndexes to accountList
                accountList = uniqueIndexes.map((index: any) => certificateToUse.accounts[index]);
            } else {
                accountList = certificateToUse.accounts;
            }

            accountList.map((curAccount: any) => {
                let jurisdictions: any = [];

                curAccount?.jurisdictionList.map((el: any) => {
                    let levies: any = [];
                    let index = jurisdictions.findIndex((obj: any) => obj.collectorId === el.collectorId && obj.jurisdictionId === el.jurisdictionId);
                    let summary = curAccount?.summaryList.filter((obj: any) => obj.collector === el.collectorName && obj.taxYear === el.taxYear);
                    let jurisdictionId = el.jurisdictionId;
                    let jurisdictionName = el.jurisdictionName;
                    let collectorId = el.collectorId;
                    let collectorAccountNumber = summary.length > 0 ? summary[0].collectorAccountNumber : null;

                    if ((jurisdictionId != null && jurisdictionId !== "" && collectorId != null && collectorId !== "" && el.placeHolder === false) || el.placeHolder === true) {
                        let taxYear = el.taxYear;
                        let levyPeriod = el.levyPeriod === "" ? null : el.levyPeriod;
                        let nextPeriodDue = el.nextPeriodDue === "" ? null : el.nextPeriodDue;
                        let nextNextPeriodDue = el.nextNextPeriodDue === "" ? null : el.nextNextPeriodDue;
                        let paidDate = el.paidDate;
                        let dueDate = el.dueDate === "" ? null : el.dueDate;
                        let billedDate = el.billedDate === "" ? null : el.billedDate;
                        let baseTax = el.baseTax;
                        let baseDue = el.baseDue;
                        let status = el.status === "" ? null : el.status;
                        let asOfDate = el.asOfDate;
                        let taxDataSource = el.taxDataSource;
                        let placeHolder = el.placeHolder;
                        let collectorId = el.collectorId;

                        if (index === -1) {
                            let obj = {
                                taxYear,
                                levyPeriod,
                                nextPeriodDue,
                                nextNextPeriodDue,
                                paidDate,
                                billedDate,
                                dueDate,
                                baseDue,
                                baseTax,
                                status,
                                collectorId
                            }
                            levies.push(obj)
                            jurisdictions.push({
                                jurisdictionId,
                                jurisdictionName,
                                collectorAccountNumber,
                                asOfDate,
                                taxDataSource,
                                collectorId,
                                levies,
                                placeHolder
                            })
                        } else {
                            let temp1 = levies.findIndex((obj: any) => obj.taxYear === el.taxYear);

                            if (temp1 !== -1) {
                                levies[temp1] = {
                                    taxYear,
                                    levyPeriod,
                                    nextPeriodDue,
                                    nextNextPeriodDue,
                                    paidDate,
                                    billedDate,
                                    dueDate,
                                    baseDue,
                                    baseTax,
                                    status,
                                    collectorId
                                }
                            } else {
                                let obj = {
                                    taxYear,
                                    levyPeriod,
                                    nextPeriodDue,
                                    nextNextPeriodDue,
                                    paidDate,
                                    billedDate,
                                    dueDate,
                                    baseDue,
                                    baseTax,
                                    status,
                                    collectorId
                                }
                                levies.push(...jurisdictions[index].levies, obj);
                            }

                            jurisdictions[index] = {
                                jurisdictionId,
                                jurisdictionName,
                                collectorAccountNumber,
                                asOfDate,
                                taxDataSource,
                                collectorId,
                                levies,
                                placeHolder
                            }
                        }
                    }
                });
                if (curAccount !== undefined) {
                    curAccount.jurisdictions = jurisdictions;

                }
            });


            const orderResultData = {
                "certificate": certificateToUse,
                "certificateOptions": {
                    "orderId": orderId,
                    "selectedCadYear": getCurrentTaxYear(),
                    "selectedTaxYear": getCurrentTaxYear(),
                },
            };

            if (isAddToParent) {
                return orderResultData;
            } else {
                let obj = {
                    "orderResultDTO": {
                        "certificate": {
                            "accounts": accountList.filter((el: any) => el !== undefined),
                            "certificateNotes": certificateToUse.certificateNotes
                        },
                        "certificateOptions": {
                            "orderId": orderId,
                            "selectedCadYear": getCurrentTaxYear(),
                            "selectedTaxYear": getCurrentTaxYear(),
                        }
                    },
                    "removedAccounts": removedAccountIds.filter((el: any) => el !== undefined)
                };

                saveOrderResult(obj).unwrap()
                    .then(() => {
                        setDisable(false);
                        setIsSavedResult(true);
                        setProductStatus('SAVED');
                        setShowAccount(0);
                        setUpdatedAccountIndexList([]);
                    })
            }
            setDisable(true);
        }
    }
    const handleGeneratePdf = async () => {
        try {
            const result = await generatePDf({
                orderId: orderId,
                customerId: customerId,
                tenant: tenant,
                checkValidation: true,
                cancelExistingTask: false
            }).unwrap();

            if (result['errorCode'] === 200) {
                setActiveTaskConfirmation(false);
                showToast("PDF created successfully!");
                setActiveTaskConfirmation(false);

                checkPdfExist({
                    'orderId': orderId, 'orderFileType': ["TaxCertificate", "CADPrintout"], 'type': 'New'
                });
                dispatch(tgxApi.util.invalidateTags(["getOrderResultByOrderId"]))

                if (result?.id) {
                    const fileUrl = `/ajax/view-file/${result.id}`;
                    const blobUrl = await fetchPdf(fileUrl); // your utility to convert file to blob URL
                    window.open(blobUrl, '_blank');
                }
            } else {
                if (result['message'] === "Can not generate PDF while task is incomplete!") {
                    setActiveTaskConfirmation(true);
                } else {
                    showToast(result["message"], "error");
                }
                setDisable(false);
            }
        } catch (error: any) {
            if (error?.data?.message === "Can not generate PDF while task is incomplete!") {
                setActiveTaskConfirmation(true);
            } else {
                showToast(error?.data?.message || "Something went wrong");
            }
        }
    };

    useEffect(() => {
        if (isAddNewSummaryRow) {
            updateNationalSummarySectionRow(certificate, showAccount, jurisdictionId, taxYear, setCertificate);
            setIsAddNewSummaryRow(false);
        }

    }, [isAddNewSummaryRow]);

    return (
        <>
            {!orderQuery.data || !showForm ? <Preloader show={true}/> :
                <div>
                    <TopSection toggleAccountSection={toggleAccountSection}
                                setToggleAccountSection={setToggleAccountSection}
                                editable={editable}
                                isUserManager={isUserManager}
                                productSchema={"NATIONAL"}
                                formType={"Tax"}
                                productStatus={productStatus}
                                orderData={orderQuery}
                                setProductStatus={setProductStatus}
                                setIsSavedResult={setIsSavedResult}
                                curProduct={curProduct}
                                setIsSendNotification={setIsSendNotification}
                                setShowDeliveryConfirmation={setShowDeliveryConfirmation}
                                isSavedResult={isSavedResult}
                                productId={productId} setProductId={setProductId} setAssignedTo={setAssignTo}
                                moduleAvailableForCounty={moduleAvailableForCounty} taskList={vendorTaskList}
                                assignedTeam={assignedTeam}
                                setAssignedTeam={setAssignedTeam}
                                setShowTeamListModal={setShowTeamListModal} showTeamListModal={showTeamListModal}
                                handleOrderResultSubmit={isJurisdictionChanged}
                                isPdfExist={isPdfExist}
                                unAcknowledged={unAcknowledged}
                                isValidDataForPdfGenerate={isValidDataForPdfGenerate}
                                setIsValidDataForPdfGenerate={setIsValidDataForPdfGenerate}
                                handleGeneratePdf={handleGeneratePdf}
                                propertyResultTaxList={propertyResultTaxList}
                                setPropertyResultTaxList={setPropertyResultTaxList}
                                taxCheckedList={taxCheckedList}
                                setTaxCheckedList={setTaxCheckedList}
                                certificateOptions={certificateOptions}
                                handleMarkAsComplete={handleMarkAsComplete}
                                disable={disable}
                                generatePDfApi={generatePDfApi.isLoading}
                                saveOrderResultApi={saveOrderResultApi.isLoading}
                                markAsCompletedApi={markAsCompletedApi.isLoading}
                                requiresQc={requiresQc}
                    />

                    <div className="md:grid sm:block grid-cols-12 gap-3 text-sm">
                        <div className="col-span-2">
                            {toggleAccountSection &&
                                <LeftBar setAddedNewAccount={setAddedNewAccount} certificate={certificate}
                                         setCertificate={setCertificate}
                                         setCertNotes={setCertNoteList}
                                         showAccount={showAccount} setShowAccount={setShowAccount}
                                         orderId={orderId} certNoteList={certNoteList}
                                         customerNoteList={customerNoteList}
                                         setIsSavedResult={setIsSavedResult} noteType={"TAX"}
                                         showDeleteAccountConfirmation={showDeleteAccountConfirmation}
                                         setShowDeleteAccountConfirmation={setShowDeleteAccountConfirmation}
                                         similarAccountList={similarAccountList}
                                         vendorTaskList={sortByKeysPriority(vendorTaskList, ["type"], ["asc"])}
                                         productType={"TAX_CERTIFICATE"}
                                         setIsFetchSimilarAccountList={setIsFetchSimilarAccountList}
                                         isFetchSimilarAccountList={isFetchSimilarAccountList}
                                         cadInfoData={cadInfoData}
                                         editable={editable}
                                         qcResultList={qcResultList}
                                         unAcknowledged={unAcknowledged}
                                         qcLogicResultData={qcLogicResultDataApiResponse}
                                         haveOrderResult={haveOrderResult}
                                         similarTaxAccountListResponse={similarTaxAccountListResponse}
                                         propertyResultTaxList={propertyResultTaxList}
                                         setPropertyResultTaxList={setPropertyResultTaxList}
                                         taxCheckedList={taxCheckedList}
                                         setTaxCheckedList={setTaxCheckedList}
                                         productId={productId}
                                         orderData={orderQuery}
                                         taxAccountNumber={taxAccountNumber}
                                         setTaxAccountNumber={setTaxAccountNumber} address={address}
                                         setAddress={setAddress} legalDescription={legalDescription}
                                         setLegalDescription={setLegalDescription}
                                         ownerName={ownerName}
                                         setOwnerName={setOwnerName}
                                         orderResultData={orderResult}
                                         setIsValidDataForPdfGenerate={setIsValidDataForPdfGenerate}
                                         assignTo={assignTo}
                                         addAccountSelectedProperty={addAccountSelectedProperty}
                                         setAddAccountSelectedProperty={setAddAccountSelectedProperty}
                                         countyData={countyDataApiResponse}
                                         setSelectedCloneAccountList={setSelectedCloneAccountList}
                                         showAccountCloneModal={showAccountCloneModal}
                                         setShowAccountCloneModal={setShowAccountCloneModal}
                                         removedAccountIds={removedAccountIds}
                                         updatedAccountIndexList={updatedAccountIndexList}
                                         setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                                         setIsFetchLinkedAccountList={setIsFetchLinkedAccountList}
                                         linkedListLoader={isFetching}
                                         getPropertyPickerResultApi={getPropertyPickerResultApi}
                                         getPropertyPickerResult={getPropertyPickerResult}
                                />
                            }
                        </div>
                        <div className={toggleAccountSection ? "col-span-10" : "col-span-12"}>
                            <SummaryInfoSection orderData={orderQuery}
                                                certificate={certificate}
                                                setCertificate={setCertificate}
                                                orderId={orderId}
                                                setIsSavedResult={setIsSavedResult}
                                                deleteNote={deleteNote}
                                                editable={editable}
                                                customerOrderNumber={orderQuery?.data?.customerOrderNumber}
                                                orderResultModifiedDate={orderResultModifiedDate}
                                                productStatus={productStatus}
                                                assignTo={assignTo}
                                                showAccount={showAccount}
                                                setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                            />

                            <RequestedInfoSection orderData={orderQuery} certificate={certificate}
                                                  showAccount={showAccount}
                                                  isHoaEditor={false}/>

                            <AccountInformation orderData={orderQuery}
                                                certificate={certificate}
                                                showAccount={showAccount}
                                                setCertificate={setCertificate}
                                                deleteNote={deleteNote}
                                                editable={editable}
                                                customerId={customerId}
                                                primaryCollector={primaryCollector}
                                                isSavedResult={isSavedResult}
                                                setIsSavedResult={setIsSavedResult}
                                                countyData={countyDataApiResponse} setAccounts={setAccounts}
                                                accounts={accounts}
                                                setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                                                addParentAccountsForSubdivision={addParentAccountsForSubdivision}
                            />
                        </div>
                    </div>
                    <div className="md:grid sm:block grid-cols-12 gap-3 text-sm">
                        {toggleAccountSection && <div className={"col-span-2 mt-2"}>
                            {(haveOrderResult || (certificate?.accounts?.length > 0 && certificate?.accounts[showAccount] !== undefined && certificate.accounts[showAccount]['cadInformation'] && certificate.accounts[showAccount]['cadInformation'].length > 0)) &&
                                <div
                                    className={"vendor_task_sidebar bg-text-1 rounded-[7px] shadow-[0_3px_10px_rgb(0_0_0_/20%)]"}>
                                    <div className={"bg-highlight-5 flex items-center text-text-0 p-2"}>
                                        <p className="mb-0">CAD
                                            Information {certificate?.accounts?.length > 0 && certificate.accounts[showAccount] !== undefined && certificate.accounts[showAccount]['cadInformation'] && '(' + certificate.accounts[showAccount]['cadInformation'].length + ')'} </p>
                                        {certificate?.accounts?.length > 0 && certificate.accounts[showAccount] !== undefined && certificate.accounts[showAccount]['cadInformation'] && certificate.accounts[showAccount]['cadInformation'].length > 0 &&
                                            <i className={loadingCadInfo ? "fas fa-sync fa-spin ml-auto h-4" : "fa fa-refresh ml-auto cursor-pointer"}
                                               title={'Refresh CAD information'} onClick={(e) => {
                                                if (editable) {
                                                    e.preventDefault();
                                                    setReloadCadInformation(true);
                                                }
                                            }}
                                            />}
                                    </div>
                                    <div
                                        className={certificate.accounts.length > 0 && certificate.accounts[showAccount]?.cadInformation && certificate.accounts[showAccount]?.cadInformation.length > 5 ? "tax_list table-responsive side_bar_table" : "tax_list table-responsive side_bar_table"}>
                                        <table
                                            className={"table table_data tax-summary-table margin_bottom_custom"}>
                                            <tbody>
                                            {certificate.accounts.length > 0 && certificate.accounts[showAccount]?.cadInformation && certificate.accounts[showAccount]?.cadInformation.length === 0 &&
                                                <tr>
                                                    <td colSpan={3}>No taxing units found</td>
                                                </tr>}
                                            {certificate.accounts.length > 0 && certificate.accounts[showAccount]?.cadInformation && certificate.accounts[showAccount]?.cadInformation.length > 0 && sortCadInfo(certificate.accounts[showAccount]?.cadInformation).map((curUnit: any) => {
                                                return (<tr className="border-t border-surface-5">
                                                    <td>
                                                        <a
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            href={'/jurisdictions' + (!curUnit['jurisdictionId'] ? '' : ('/' + curUnit['jurisdictionId']))}
                                                            title={curUnit?.taxingUnitSource ?? '-'}
                                                            className="text-highlight-4 hover:underline"
                                                        >
                                                            {curUnit?.taxingUnit}
                                                        </a>

                                                    </td>
                                                    <td>
                                                            <span
                                                                title={curUnit?.jurisdictionName}>{curUnit?.jurisdictionName > 10 ? curUnit?.jurisdictionName.substring(0, 10) + '...' : curUnit?.jurisdictionName}
                                                            </span>
                                                    </td>
                                                </tr>)
                                            })}

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            }
                        </div>
                        }
                        <div className={toggleAccountSection ? "col-span-10" : "col-span-12"}>
                            <div className={'bg-text-1 rounded-b-[7px] shadow-md p-2'}>
                                <div className="detail-style unset_border_top bg-text-1 rounded-[7px] shadow-md">
                                    <JurisdictionSection curAccount={certificate.accounts[showAccount]}
                                                         setShowAccount={setShowAccount}
                                                         accounts={accounts}
                                                         setAccounts={setAccounts}
                                                         setIsSavedResult={setIsSavedResult}
                                                         autoCalculate={autoCalculate}
                                                         setAutoCalculate={setAutoCalculate}
                                                         certificate={certificate}
                                                         setCertificate={setCertificate}
                                                         showAccount={showAccount}
                                                         jurisdictionId={jurisdictionId}
                                                         setJurisdictionId={setJurisdictionId}
                                                         removeJurisdiction={removeJurisdiction}
                                                         setRemoveJurisdiction={setRemoveJurisdiction}
                                                         setIsAddNewSummaryRow={setIsAddNewSummaryRow}
                                                         setTaxYear={setTaxYear}
                                                         clearJurisRow={clearJurisRow}
                                                         setClearJurisRow={setClearJurisRow}
                                                         setUpdateTotalTaxValue={setUpdateTotalTaxValue}
                                                         editable={editable}
                                                         county={orderQuery?.data.countyId}
                                                         orderId={orderId}
                                                         setRender={setRender}
                                                         primaryCollector={primaryCollector}
                                                         updatedAccountIndexList={updatedAccountIndexList}
                                                         setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                                    />
                                </div>
                            </div>
                        </div>

                    </div>


                    {showAddTaxSuitCommentModal && <EditorAddEditNoteForm title={"Add Tax Suit Note"}
                                                                          show={showAddTaxSuitCommentModal}
                                                                          setShow={setShowAddTaxSuitCommentModal}
                                                                          index={null}
                                                                          certificate={certificate}
                                                                          setCertificate={setCertificate}
                                                                          orderId={orderId}
                                                                          showAccount={showAccount}
                                                                          setIsSavedResult={setIsSavedResult}
                                                                          length={certificate.accounts[showAccount]?.taxSuitNotes.length + 1}
                                                                          isTaxSuit={true}
                                                                          setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                    />}

                    {showUpdateTaxSuitCommentModal && <EditorAddEditNoteForm title={"Update Tax Suit Note"}
                                                                             show={showUpdateTaxSuitCommentModal}
                                                                             setShow={setShowUpdateTaxSuitCommentModal}
                                                                             index={noteIndex}
                                                                             certificate={certificate}
                                                                             setCertificate={setCertificate}
                                                                             orderId={orderId}
                                                                             showAccount={showAccount}
                                                                             setIsSavedResult={setIsSavedResult}
                                                                             isTaxSuit={true}
                                                                             setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                    />}
                    {warningBondModal ? <ConfirmationModal title={"Delete Bond"}
                                                           bodyMessage={<><p>Delete Jurisdiction will delete
                                                               existing
                                                               related bond as
                                                               well.</p>
                                                               <p>Continue ?</p></>}
                                                           onSubmit={removeJurisdictionAndBonds}
                                                           show={warningBondModal}
                                                           setShow={setWarningBondModal}/> : <></>}


                    {activeTaskConfirmation ? <GenerateActivePdf show={activeTaskConfirmation}
                                                                 setShow={setActiveTaskConfirmation}
                                                                 orderId={orderId}
                                                                 customerId={customerId}
                                                                 tenant={tenant} type={"taxCert"}
                                                                 productType={products.type}
                                                                 setIsValidDataForPdfGenerate={setIsValidDataForPdfGenerate}
                                                                 orderResult={orderResult.data}
                                                                 productSchema={"National"}
                                                                 setIsPdfExist={setIsPdfExist}
                    /> : <></>}

                    {showDeliveryConfirmation && isArray(docList) &&
                        <PdfDeliveryConfirmationModal title={"Deliver Documents"}
                                                      body={"Select the documents you would like to deliver"}
                                                      docList={docList}
                                                      deliveryEmail={deliveryEmail}
                                                      setDeliveryEmail={setDeliveryEmail}
                                                      show={showDeliveryConfirmation}
                                                      setShow={setShowDeliveryConfirmation}
                                                      disable={disable}
                                                      setDisable={setDisable}
                                                      orderId={orderId}
                                                      productType={products.type}
                                                      isSendNotification={isSendNotification}
                                                      fileType={"TaxCertificate"}
                                                      isHoaOrder={false}
                                                      orderData={orderQuery}
                                                      includeCadPrintout={orderQuery?.data?.branchDTO?.includeCadPrintout}
                                                      setDocList={setDocList}
                        />
                    }

                    {isJurisdictionUpdated && <ConfirmationModal title={"Warning"}
                                                                 bodyMessage={<><p>Updating Jurisdiction will cancel
                                                                     existing Bonds
                                                                     Task.</p><p>Continue
                                                                     ?</p></>}
                                                                 onSubmit={async () => {
                                                                     await handleOrderResultSubmit();
                                                                 }}
                                                                 show={isJurisdictionUpdated}
                                                                 setShow={setIsJurisdictionUpdated}/>}

                    {warningModal && <ConfirmationModal title={"Alert"}
                                                        bodyMessage={warningModalBody}
                                                        onSubmit={null} show={warningModal}
                                                        setShow={setWarningModal}/>}

                    {lockEditorPopUp &&
                        <LockConfirmationPopUp formType={"taxCert"} show={lockEditorPopUp}
                                               setShow={setLockEditorPopUp}
                                               orderId={orderId} setEditable={setEditable} productId={productId}/>
                    }
                </div>
            }
        </>
    )
}
export default TaxDetailTabSection


export function dummyAssessmentList() {
    let currentTaxYear = getCurrentTaxYear();
    let desiredYear = doesCurrentTaxYearMatchCurrentYear() ? currentTaxYear + 1 : currentTaxYear - 1;

    let assessment = {
        "taxYear": desiredYear > currentTaxYear ? currentTaxYear : desiredYear,
        "improvementMarketValue": null,
        "landMarketValue": null,
        "agMarketValue": null,
        "overrideAppraisedValue": null,
        "overrideAssessedValue": null,
        "agTimberValue": null,
        "agLossValue": null,
        "RsteadCapValue": 0,
        "exemptions": [],
        "assessedValue": null,
        "agriculturalValue": null,
        "landTotalValue": null,
        "overrideAgValue": null,
        "appraisedValue": null,
        "certified": false,
        "overrideLandTotalValue": null,
        "woExemptionAmount": null,
        "overrideWoExemptionAmount": null,
        "withExemptionEstimate": null,
        "withExemptionEstimateOverride": null,
    };

    return [
        {
            ...assessment,
            "taxYear": desiredYear > currentTaxYear ? currentTaxYear : desiredYear,
        },
        {
            ...assessment,
            "taxYear": desiredYear > currentTaxYear ? desiredYear : currentTaxYear,
        }
    ]
}

export function getUniqueLatestYearJurisdictions(jurisdictionList: any) {
    let list = [];
    for (let i = 0; i < jurisdictionList.length; i++) {
        if (jurisdictionList[i]['jurisdictionId'] !== '' && jurisdictionList[i]['jurisdictionId'] !== null && jurisdictionList[i]['inActive'] !== true && jurisdictionList[i]['nonCollecting'] !== true) {
            let index: any = list.findIndex(obj => obj.jurisdictionName === jurisdictionList[i]['jurisdictionName']);
            if (index > -1) {
                if (parseInt(jurisdictionList[i]['bill_year']) > parseInt(list[index]['bill_year'])) {
                    list[index] = jurisdictionList[i];
                }
            } else {
                list.push(jurisdictionList[i]);
            }
        }
    }
    return list;
}

